<template>
  <div class="xc-modal xc-modal-page">
    <div class="xc-modal-wrap">
      <div class="xc-modal-content">
        <div class="xc-modal-header">
          <div class="xc-modal-title">文件减播</div>
          <div class="xc-modal-close" @click="layerClose"></div>
        </div>
        <div class="xc-modal-body">
            <div class="xc-device-group-head">请选择减播素材<span v-if="Object.keys(this.checkedList).length">（共选择{{webSum}}个广告素材，{{imageSum}}个图片素材，{{videoSum}}个视频素材）</span></div>
            <div class="xc-form-inline">
              <div class="xc-device-row-item">
                <span class="xc-device-row-title">素材名称</span>
                <input v-model="mix_query.sourceName" type="text" maxlength="255" class="xc-device-input" placeholder="请输入素材名称">
              </div>
              <button type="submit" class="xc-btn xc-btn-primary" @click.prevent="mix_search">查询</button>
            </div>
            <!-- 带滚动条的表格 -->
            <div class="xc-row-scroll">
              <table class="xc-table">
                <thead>
                  <th>
                    <input type="checkbox" class="xc-checkbox" v-model="mix_isSelectAll">
                  </th>
                  <th>节目名称</th>
                  <th>节目素材</th>
                  <th>创建时间</th>
                  <th>下放时间</th>
                  <th>投放开始时间</th>
                  <th>投放结束时间</th>
                  <th>累计播放次数</th>
                </thead>
                <tbody>
                  <template v-if="list && list.length">
                    <tr v-for="(item,key) in list" :key="key">
                      <td style="width: 45px;">
                        <input
                          type="checkbox"
                          class="xc-checkbox"
                          v-model="item.mix_checkbox"
                          @click="mix_selectListItem(item)"
                        >
                      </td>
                      <td>{{item.programName}}</td>
                      <td>
                        <div
                          class="xc-device-material-program"
                          :key="key"
                          :data-index="key"
                        >
                          <img :src="item.fileImageUrl" alt="素材图"
                            :data-filename="item.fileName"
                            :data-filetype="item.fileType"
                            :data-url="item.url"
                            @click="viewMaterial"
                          >
                          <div class="xc-device-material-name">{{item.fileName}}</div>
                        </div>
                      </td>
                      <td>{{item.addTime}}</td>
                      <td>{{item.pushTime}}</td>
                      <td>{{item.putinStartTime}}</td>
                      <td>{{item.putinEndTime}}</td>
                      <td>{{item.playCount}}次</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="9" class="xc-s-tac">暂无数据</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="layerClose">取消</div>
              <div class="xc-btn xc-btn-primary" @click="mix_batchAction('reducePlay',$event)">确定减播</div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import myLayerImport from "@/libs/myLayer";
import mixin from "../xc-ui/mixins/list";
import deviceApi from "../api/device";

// vee-validate验证
import "@/libs/vee-validate";
import "@/utils/form-format";

export default {
  name: "materialPreview",
  data() {
    return {
      channel: 1,
      deviceCode: this.$route.query.deviceCode,
      list: [],
      programName: '',
      // 默认查询参数
      mix_query: {
        sourceName: '',
      },

      // 获取参数
      program: this.$route.query,

      // 减播素材
      reduceMaterialValue: [
        {
          programName: "酒类营销",
          programMaterial: "",
          createTime: "2019-4-12 23:59:59",
          delegateTime: "2019-4-12 23:59:59",
          putStartTime: "2019-4-12 23:59:59",
          putEndTime: "2019-4-12 23:59:59",
          CumPlayTimes: "100",
          CumPlayTime: "10"
        },
        {
          programName: "酒类营销",
          programMaterial: "",
          createTime: "2019-4-12 23:59:59",
          delegateTime: "2019-4-12 23:59:59",
          putStartTime: "2019-4-12 23:59:59",
          putEndTime: "2019-4-12 23:59:59",
          CumPlayTimes: "100",
          CumPlayTime: "10"
        },
        {
          programName: "酒类营销",
          programMaterial: "",
          createTime: "2019-4-12 23:59:59",
          delegateTime: "2019-4-12 23:59:59",
          putStartTime: "2019-4-12 23:59:59",
          putEndTime: "2019-4-12 23:59:59",
          CumPlayTimes: "100",
          CumPlayTime: "10"
        },
        {
          programName: "酒类营销",
          programMaterial: "",
          createTime: "2019-4-12 23:59:59",
          delegateTime: "2019-4-12 23:59:59",
          putStartTime: "2019-4-12 23:59:59",
          putEndTime: "2019-4-12 23:59:59",
          CumPlayTimes: "100",
          CumPlayTime: "10"
        },
        {
          programName: "酒类营销",
          programMaterial: "",
          createTime: "2019-4-12 23:59:59",
          delegateTime: "2019-4-12 23:59:59",
          putStartTime: "2019-4-12 23:59:59",
          putEndTime: "2019-4-12 23:59:59",
          CumPlayTimes: "100",
          CumPlayTime: "10"
        },
        {
          programName: "酒类营销",
          programMaterial: "",
          createTime: "2019-4-12 23:59:59",
          delegateTime: "2019-4-12 23:59:59",
          putStartTime: "2019-4-12 23:59:59",
          putEndTime: "2019-4-12 23:59:59",
          CumPlayTimes: "100",
          CumPlayTime: "10"
        },
        {
          programName: "酒类营销",
          programMaterial: "",
          createTime: "2019-4-12 23:59:59",
          delegateTime: "2019-4-12 23:59:59",
          putStartTime: "2019-4-12 23:59:59",
          putEndTime: "2019-4-12 23:59:59",
          CumPlayTimes: "100",
          CumPlayTime: "10"
        }
      ],
    };
  },

  computed: {
    checkedList(){
      let checkedList
      const { mix_checkedList } = this;
      checkedList = mix_checkedList

      return checkedList
    }

  },

  async created() {
    // 加载JS
    await myLayerImport();
  },

  mounted() {
    let that = this;
  },

  watch: {
    checkedList(newValue) {
      this.webSum = 0
      this.imageSum = 0
      this.videoSum = 0
      for (let i in newValue) {
        if (newValue[i].fileType == 'web') {
          this.webSum ++
        } else if (newValue[i].fileType == 'image') {
          this.imageSum ++
        } else if (newValue[i].fileType == 'video') {
          this.videoSum ++
        }
      }
    }
  },

  methods: {
    layerClose() {
      var index = parent.layer.getFrameIndex(window.name);
      parent.layer.close(index);
    },

    // 初始化数据
    initData(v) {
      // 默认搜索的数据
      const search = {
        pageNum: -1,
        ...this.mix_query
      };

      deviceApi.getCurrentSourcesByDeviceCode(search).then(v => {
        let ret = v;
        this.list = this.mix_format(ret.data);
      });
    },

    // 批量操作
    batchAction(...args) {
      let that = this;
      const action = args[0];
      const e = args[args.length - 1];

      // 批量操作的数据
      const { mix_checkedList } = this;

      switch (action) {

        // 批量发布
        case "reducePlay":

          // 获取sourceJson参数
          let sourceJson = JSON.stringify(mix_checkedList)
          deviceApi.programReduce(this.deviceCode, sourceJson).then(v => {

            // 成功后关闭窗口
            // that.initData()
            that.$message.success(v.msg)
            that.layerClose()
          })

          break;

        default:
          break;
      }
    },

    //预览素材
    viewMaterial(e) {
      let data = e.target.dataset;

      var program = {
        name: data.filename,
        type: data.filetype,
        url: data.url
      };
      myLayer.open({
        type: 2,
        title: false,
        shadeClose: true,
        closeBtn: 0, //不显示关闭按钮
        area: ["981px", "550px"],
        content:
          "/admin/material/preview?name=" +
          program.name +
          "&type=" +
          program.type +
          "&url=" +
          program.url,
        success: function(layero, index) {
          
        }
      });
    },

  },
  mixins: [mixin]
};
</script>

<style lang="scss" scoped>
.material {
  width: 100%;
  height: 100%;
  .myMaterial {
    width: 100%;
    height: 100%;
    border: 0;
  }
}

.xc-device-group-head {
  font-size: 14px;
  color: #6e7a90;
  margin-bottom: 16px;
}

.xc-device-group {
  display: flex;
}

.xc-device-group-title {
  width: 40px;
  line-height: 24px;
}

.xc-device-group-main {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
}

.xc-device-group-main-close {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  height: 38px;
  position: relative;
  padding-right: 84px;
  box-sizing: border-box;
}

.xc-device-group-close,
.xc-device-group-open {
  display: flex;
  align-items: center;
  color: #507dde;
  margin-bottom: 14px;
  cursor: pointer;
}

.xc-device-group-close span,
.xc-device-group-open span {
  margin-right: 2px;
}

.xc-device-group-close span {
  margin-left: 5px;
}

.xc-device-group-close img,
.xc-device-group-open img {
  width: 9px;
  height: 6px;
}

.xc-device-group-open img {
  transform: rotate(180deg);
}

.xc-device-group-open {
  position: absolute;
  top: 0;
  right: 40px;
}

.xc-device-group-item {
  padding: 5px 12px;
  line-height: 14px;
  font-size: 14px;
  color: #6e7a90;
  margin-bottom: 14px;
  cursor: pointer;
}

.xc-device-group-item:hover {
  color: rgba(80, 125, 222, 0.5);
}

.xc-device-group-item-checked {
  padding: 5px 12px;
  line-height: 14px;
  font-size: 14px;
  color: #fff;
  background: rgba(80, 125, 222, 0.5);
  border-radius: 8px;
  margin-bottom: 14px;
  cursor: pointer;
}

.xc-device-material {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.xc-device-material-item,
.xc-device-material-item-checked,
.xc-device-material-program,
.xc-device-material-program-checked {
  width: 222px;
  height: 127px;
  border-radius: 4px;
  background: #eee;
  margin-right: 16px;
  position: relative;
  display: flex;
  // align-items: center;
  // justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
}

.xc-device-material-program,
.xc-device-material-program-checked {
  margin-right: 0;
}


.xc-device-material-name {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 21px;
  background-color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: white;
  font-size: 12px;
}

.xc-device-material-program img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.xc-device-material-program-checked img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.xc-device-material-item:nth-child(4n),
.xc-device-material-item-checked:nth-child(4n) {
  margin-right: 0;
}

.xc-device-row-item {
  display: flex;
  align-items: center;
}

.xc-device-row-title {
  margin-right: 8px;
}

.xc-device-input {
  flex: 1;
  width: 220px;
  height: 32px;
  line-height: 32px;
  padding: 0 10px;
  background-color: #ffffff;
  border-radius: 6px;
  border: solid 1px #cfd5e0;
  color: #808b9e;
  font-size: inherit;
  margin-right: 14px;
}

::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #cfd5e0;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #cfd5e0;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #cfd5e0;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #cfd5e0;
}

.xc-device-tipText {
  font-size: 18px;
	color: #6e7a90;
}

</style>
